import React from "react";

import { IgTypography, Styles } from "@intelligems/ig-theme";
import type { StackProps } from "@mui/material/Stack";
import Stack from "@mui/material/Stack";
import * as Sentry from "@sentry/react";

interface ErrorBoundaryMessageProps extends StackProps {}

const styles = {
  main: {
    py: 4,
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
} satisfies Styles;

export const ErrorBoundaryMessage = ({
  children,
  sx,
  ...rest
}: ErrorBoundaryMessageProps) => {
  return (
    <Stack sx={{ ...styles.main, ...sx }} {...rest}>
      {children || (
        <IgTypography variant={"h4"}>Oops! Something went wrong!</IgTypography>
      )}
    </Stack>
  );
};

export const IgErrorBoundary = (props: Sentry.ErrorBoundaryProps) => {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorBoundaryMessage />} {...props} />
  );
};

export default IgErrorBoundary;

export class HiddenErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  // eslint-disable-next-line node/handle-callback-err
  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
